import { useEffect, useState } from "react";

// Bumps whenever the F2/Alt+F2 date filter changes, so the CURRENT screen
// refetches its data in place (no remount, no redirect, no page reload).
export function useDateFilterVersion() {
  const [v, setV] = useState(0);
  useEffect(() => {
    const f = () => setV((x) => x + 1);
    window.addEventListener("datefilter-changed", f);
    return () => window.removeEventListener("datefilter-changed", f);
  }, []);
  return v;
}
